import React from 'react';
import { DetalleOT, EvidenciaImg } from '../../types/ot.types';
import { EvidenciasReparacionPorConcepto } from '../EvidenciasReparacionPorConcepto';

interface Step4Props {
    detallesOT: DetalleOT[];
    evidenciasReparacion: Record<number, EvidenciaImg[]>;
    evidenciasCierre: Record<number, EvidenciaImg[]>;
    setEvidenciasReparacion: React.Dispatch<React.SetStateAction<Record<number, EvidenciaImg[]>>>;
    setEvidenciasCierre: React.Dispatch<React.SetStateAction<Record<number, EvidenciaImg[]>>>;
    excepcionesEvidencia: number[];
    setExcepcionesEvidencia: React.Dispatch<React.SetStateAction<number[]>>;
    isCompleted?: boolean;
}

export const Step4Evidencias: React.FC<Step4Props> = ({
    detallesOT, evidenciasReparacion, evidenciasCierre, setEvidenciasReparacion,
    setEvidenciasCierre, excepcionesEvidencia, setExcepcionesEvidencia, isCompleted = false
}) => {
    return (
        <div id="ot-step4-evidencias">
            {isCompleted && (
                <div className="mb-3 text-success fw-bold small">
                    <i className="fas fa-check-circle me-1"></i> Evidencias guardadas y bloqueadas.
                </div>
            )}
            <EvidenciasReparacionPorConcepto
                detallesOT={detallesOT}
                evidenciasInicio={evidenciasReparacion}
                evidenciasCierre={evidenciasCierre}
                setEvidenciasInicio={setEvidenciasReparacion}
                setEvidenciasCierre={setEvidenciasCierre}
                excepcionesEvidencia={excepcionesEvidencia}
                setExcepcionesEvidencia={setExcepcionesEvidencia}
                modo="completo"
                isCompleted={isCompleted}
            />
        </div>
    );
};
